/*
 * @Author: co
 * @Date: 2021-06-30 10:12:40
 */
import * as util from '@/libs/util';
import router from '@/router';
import {
	sms, saveRentTakeLookRecord
} from '@api/OrderToSeeHouse';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		Entities: cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		// 预约看房-发送短信
		sms({ state }, obj) {
			return new Promise((resolve, reject) => {
				sms(obj)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		// 预约看房-提交
		saveRentTakeLookRecord({ state }, obj) {
			return new Promise((resolve, reject) => {
				saveRentTakeLookRecord(obj)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
